/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../core/IceEntity';

export class viralstat extends IceEntity {
  hiv_total: number = 0;
  hiv_positive_total: number = 0;
  hiv_vaccination_total: number = 0;
  hiv_dealth_total: number = 0;

  hepb_total: number = 0;
  hepb_positive_total: number = 0;
  hepb_vaccination_total: number = 0;
  hepb_dealth_total: number = 0;

  hepc_total: number = 0;
  hepc_positive_total: number = 0;
  hepc_vaccination_total: number = 0;
  hepc_dealth_total: number = 0;

  vdrl_total: number = 0;
  vdrl_positive_total: number = 0;
  vdrl_vaccination_total: number = 0;
  vdrl_dealth_total: number = 0;

  covid19_total: number = 0;
  covid19_positive_total: number = 0;
  covid19_vaccination_total: number = 0;
  covid19_dealth_total: number = 0;
  covid19_moderna_vaccination_total: number = 0;
  covid19_pfizer_vaccination_total: number = 0;
  covid19_astrazeneca_vaccination_total: number = 0;
  covid19_johnsonjohnson_vaccination_total: number = 0;

  public gettablename(): string {
    return "VIRAL_STAT";
  }
}
